import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AccueilComponent} from "./accueil/accueil.component";
import {ForbiddenComponent} from '@Common/forbidden/forbidden.component';
import {AuthGuardService} from '@Services/auth';

const appRoutes: Routes = [
  {
    path: '',
    children: [
      {path: '', component: AccueilComponent, canActivate: [AuthGuardService]},
      {path: 'gestion', loadChildren: () => import('./gestion/gestion.module').then((m) => m.GestionModule)},
      // {path: 'demandeur', loadChildren: () => import('./applicant/applicant.module').then(m => m.ApplicantModule)},
      {path: 'versement', loadChildren: () => import('./applicant/applicant.module').then(m => m.ApplicantModule)},
      {path: 'consultation', loadChildren: () => import('./loaning/loaning.module').then(m => m.LoaningModule)},
      {path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)},
    ]
  },
  {
    path: 'forbidden', component: ForbiddenComponent
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {})
  ],
  exports: [
    RouterModule,
  ]
})
export class AppRoutingModule {
}
